import {
  Box,
  Button,
  InputAdornment,
  Paper,
  TextField,
  Typography,
} from '@material-ui/core/';
import {
  LockOutlined as LoginIcon,
  VpnKey as KeyIcon,
  Person as PersonIcon,
} from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';
import React, { ChangeEvent, FormEvent, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, useHistory } from 'react-router-dom';
import { AuthState, Credentials, login } from '../../../state/auth';
import { AppState } from '../../../state/configureStore';

const useStyles = makeStyles((theme) => ({
  flexContainer: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    minHeight: 'calc(100vh - 64px)',
  },
  form: {
    marginTop: theme.spacing(1),
    width: '100%',
  },
  formContainer: {
    background:
      'linear-gradient(180deg, rgba(255,255,255,0.96) 0%, rgba(248,250,255,0.92) 100%)',
    alignItems: 'center',
    border: '1px solid rgba(226, 232, 240, 0.9)',
    borderRadius: 28,
    boxShadow: '0 28px 70px rgba(15, 23, 42, 0.14)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    maxWidth: 450,
    padding: theme.spacing(4, 3),
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(4.5, 4.5),
    },
  },
  rootBox: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    // padding x:2, y:4
    padding: theme.spacing(4, 2),
    // break-out full bleed but slightly less than 100vw to avoid scrollbar
    width: '100vw',
    marginLeft: 'calc(50% - 50vw)',
    marginRight: 'calc(50% - 50vw)',
    boxSizing: 'border-box',
    overflow: 'hidden',
    background:
      'radial-gradient(circle at 8% 12%, rgba(99,102,241,0.14) 0%, rgba(99,102,241,0.06) 30%, transparent 45%), radial-gradient(circle at 92% 88%, rgba(168,85,247,0.12) 0%, rgba(168,85,247,0.04) 30%, transparent 45%), linear-gradient(135deg, #f6f8ff 0%, #ffffff 56%, #f3f5ff 100%)',
    '&:before': {
      content: '""',
      position: 'absolute',
      left: '8%',
      top: '6%',
      width: 260,
      height: 260,
      borderRadius: '50%',
      background: 'rgba(99,102,241,0.10)',
      filter: 'blur(28px)',
      transform: 'translate(-10%, -5%)',
    },
    '&:after': {
      content: '""',
      position: 'absolute',
      right: '6%',
      bottom: '6%',
      width: 320,
      height: 320,
      borderRadius: '50%',
      background: 'rgba(168,85,247,0.10)',
      filter: 'blur(36px)',
      transform: 'translate(8%, 8%)',
    },
  },
  avatar: {
    backgroundColor: '#1d4ed8',
    boxShadow: '0 12px 30px rgba(29, 78, 216, 0.35)',
    height: 68,
    margin: theme.spacing(1),
    width: 68,
  },
  avatarIcon: {
    fontSize: 34,
  },
  topIconOuter: {
    width: 64,
    height: 64,
    borderRadius: '50%',
    backgroundColor: '#ffffff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 12px 30px rgba(15, 23, 42, 0.06)',
    marginBottom: theme.spacing(1.5),
  },
  topIconInner: {
    width: 56,
    height: 56,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(135deg, #6366f1 0%, #a855f7 100%)',
    boxShadow: '0 8px 20px rgba(99,102,241,0.12)',
  },
  label: {
    color: '#0f172a',
    fontWeight: 800,
    letterSpacing: '-0.03em',
    marginTop: theme.spacing(1),
  },
  subtitle: {
    color: '#64748b',
    marginBottom: theme.spacing(3),
    marginTop: theme.spacing(1),
    maxWidth: 300,
    textAlign: 'center',
  },
  fieldLabel: {
    color: '#334155',
    fontWeight: 700,
    marginBottom: theme.spacing(0.75),
  },
  inputRoot: {
    backgroundColor: 'rgba(248, 250, 252, 0.9)',
    borderRadius: 8,
    paddingLeft: 8,
    transition: 'all 180ms ease',
    '& fieldset': {
      borderColor: 'rgba(148, 163, 184, 0.28)',
    },
    '&:hover fieldset': {
      borderColor: 'rgba(59, 130, 246, 0.4)',
    },
    '&$inputFocused': {
      backgroundColor: '#ffffff',
      boxShadow: '0 0 0 4px rgba(99,102,241,0.12)',
      '& fieldset': {
        borderColor: 'rgba(99,102,241,0.9)',
      },
    },
    // Handle browser autofill (Chrome)
    '& input:-webkit-autofill': {
      WebkitBoxShadow: '0 0 0 1000px #ffffff inset',
      WebkitTextFillColor: '#0f172a',
      borderRadius: 8,
    },
    '& input:-webkit-autofill:focus': {
      WebkitBoxShadow: '0 0 0 1000px #ffffff inset',
      WebkitTextFillColor: '#0f172a',
    },
  },
  inputFocused: {},
  usernameField: {
    marginBottom: theme.spacing(2.25),
  },
  passwordField: {
    marginBottom: theme.spacing(1),
  },
  helperText: {
    color: '#64748b',
    display: 'block',
    marginTop: theme.spacing(1.25),
  },
  submit: {
    background: 'linear-gradient(90deg, #2563eb 0%, #7c4dff 100%)',
    borderRadius: 12,
    boxShadow: '0 10px 24px rgba(124, 77, 255, 0.16)',
    fontSize: '1rem',
    fontWeight: 700,
    margin: theme.spacing(3, 0, 0),
    minHeight: 48,
    textTransform: 'none',
    '&:hover': {
      background: 'linear-gradient(90deg, #1e63e8 0%, #6d3de6 100%)',
      boxShadow: '0 12px 30px rgba(124, 77, 255, 0.2)',
    },
  },
}));

interface AuthLocationState {
  from?: {
    pathname: string;
    search?: string;
  };
}

const Auth: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const classes = useStyles();
  const [credentials, setCredentials] = useState<Credentials>({
    password: '',
    username: '',
  });
  const { isLoggedIn } = useSelector<AppState, AuthState>((state) => state.auth);
  const handleSubmit = (event: FormEvent<HTMLFormElement>): void => {
    event.preventDefault();
    dispatch(login(credentials));
  };

  const handleChange = (event: ChangeEvent<HTMLInputElement>): void => {
    const { target } = event;
    setCredentials((prevState) => ({
      ...prevState,
      [target.name]: target.value,
    }));
  };

  const { location } = history;
  const locationState = (location.state as AuthLocationState) || {};
  const from = locationState.from || {
    pathname: '/dashboard',
    search: location.search,
  };

  return isLoggedIn ? (
    <Redirect to={from} />
  ) : (
    // <div className={classes.flexContainer}>
    <Box className={classes.rootBox}>
      <Paper className={classes.formContainer} elevation={24}>
        <div className={classes.topIconOuter}>
          <div className={classes.topIconInner}>
            <LoginIcon style={{ color: '#fff', fontSize: 28 }} />
          </div>
        </div>
        <Typography component="h1" variant="h4" className={classes.label}>
          Sign in
        </Typography>
        <Typography variant="body2" className={classes.subtitle}>
          Sign in with your Windows account to continue to the sales management system.
        </Typography>
        <form className={classes.form} onSubmit={handleSubmit} noValidate>
          <Typography variant="body2" className={classes.fieldLabel}>
            Username
          </Typography>
          <TextField
            className={classes.usernameField}
            variant="outlined"
            required
            fullWidth
            id="username"
            name="username"
            autoComplete="username"
            autoFocus
            onChange={handleChange}
            value={credentials.username}
            size="small"
            InputProps={{
              classes: {
                focused: classes.inputFocused,
                root: classes.inputRoot,
              },
              startAdornment: (
                <InputAdornment position="start">
                  <PersonIcon color="action" />
                </InputAdornment>
              ),
            }}
            placeholder="Username"
          />
          <Typography variant="body2" className={classes.fieldLabel}>
            Password
          </Typography>
          <TextField
            className={classes.passwordField}
            variant="outlined"
            required
            fullWidth
            name="password"
            type="password"
            id="password"
            size="small"
            onChange={handleChange}
            value={credentials.password}
            autoComplete="current-password"
            InputProps={{
              classes: {
                focused: classes.inputFocused,
                root: classes.inputRoot,
              },
              startAdornment: (
                <InputAdornment position="start">
                  <KeyIcon color="action" />
                </InputAdornment>
              ),
            }}
            placeholder="Password"
          />
          <Typography variant="caption" className={classes.helperText}>
            Use the same credentials as your Windows account.
          </Typography>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
          >
            Sign In Windows
          </Button>
        </form>
      </Paper>
    </Box>
    // </div>
  );
};

export default Auth;
